<template>
    <CustomTopSheetDialog v-model="dialogVisible" :width="900" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                {{ $t('global.menu.backoffice.findShopWithFeature', { feature: formData?.name }) }}
            </h3>
        </template>

        <template #default>

            <v-row class="shop-info-container" justify="start">

                <!-- <v-col cols="12" md="12">
                    {{ areas }}
                </v-col> -->
                <v-col cols="12">
                    <v-data-table-server v-model:items-per-page="itemsPerPage" :items-per-page-options="pageOptions"
                        density="compact" :headers="headers" :items="serverItems" :items-length="totalItems"
                        :loading="loading" :search="search" item-value="name" @update:options="loadItems"
                        :mobile="['xs', 'sm', 'md'].includes($globalState.screenWidth)" class="shop-list-table"
                        fixed-header>
                        <template v-slot:top>
                            <v-row>
                                <v-col>
                                    <!-- TODO BACKEND SEARCH FUNCTION PAGINATION -->
                                    <v-autocomplete v-model="search" :items="areas" :item-title="`properties.name${selectedLanguage.toUpperCase()}`"
                                        :placeholder="$t('main.search.placeholder')" variant="outlined" return-object
                                        hide-details="true" density="compact" class="pb-2 py-0 bg-white" height="32px">
                                        <template v-slot:prepend-inner>
                                            <v-icon icon="mdi-magnify"></v-icon>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="4" class="text-right">
                                    
                                </v-col>
                            </v-row>
                        </template>

                        <template v-slot:[`item.labelCategory`]="{ value }">
                            {{ value.name }} | {{ value.frontendId }}
                        </template>
                        <template v-slot:[`item.controls`]="props">
                            <v-btn color="primary" variant="flat" size="32" class="mr-1"
                                @click="() => editLabel(props.item)">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn color="error" variant="flat" size="32" class="mr-1">
                                <v-icon>mdi-trash-can-outline</v-icon>
                            </v-btn>
                        </template>

                    </v-data-table-server>
                </v-col>
            </v-row>

            <!-- <v-treeview v-model="selectedLocations" :items="items" item-value="id" 
                        selectable open-on-click density="compact" :lines="false" @update:selected="add">
                        <template v-slot:title="{ item }">
                            {{ item.nameTranslations ? item.nameTranslations[`name${selectedLanguage.toUpperCase()}`] :
                                item.properties[`name${selectedLanguage.toUpperCase()}`] }}
                                {{ item.id }}
                        </template>
                    </v-treeview> -->


        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="closeSheet">{{ $t('entity.action.cancel') }}</v-btn>
                <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-content-save"
                    color="primary" @click="save">{{ $t('global.form.save') }}</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
export default {
    name: "CreateLabelDialog",
    data() {
        return {

        }
    },
};
</script>
<script setup>
import { ref, inject, onMounted, computed, watch, getCurrentInstance, defineProps, defineEmits, defineModel } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';
import LabelCategories from '../LabelCategories.vue';
import PremiumFeatures from '../PremiumFeatures.vue';


const dialogVisible = defineModel(); // Handles v-model for visibility
const formData = defineModel("data", { default: () => ({ translations: {} }) }); // Handles v-model for the object
const selectedLanguage = localStorage.getItem('selectedLanguage');
const props = defineProps({
    save: Function, // Define prop as a function
    items: Array
});
const { proxy } = getCurrentInstance();
const parent = ref(null)
const selectedCountry = ref({ children: [] })
const selectedLocations = ref([]);


const itemsPerPage = ref(25)

const pageOptions = [
    { value: 25, title: '25' },
    { value: 50, title: '50' },
    // { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
]

const headers = ref([
    { title: 'id', key: 'id', align: 'start' },
    { title: 'name', key: 'name', align: 'start' },
    { title: 'city', key: 'city', align: 'start' },
])
const search = ref('')
const serverItems = ref([])
const loading = ref(true)
const totalItems = ref(0)
const labelCategories = ref([])
const areas = inject('areas');

watch(() => areas.value, (newValue) => {
    console.log(newValue);
}, { immediate: true });

const loadItems = async ({ page, itemsPerPage, sortBy }) => {
    loading.value = true;
    if (search.value == '' || search.value == null) {
        loading.value = false;
        return;
    }
    // console.log(this.search)
    const softToken = localStorage.getItem("softToken");
    const hardToken = localStorage.getItem("hardToken");
    const username = localStorage.getItem("username");
    const obj = { PremiumFeatures: [formData.value.name], cityIDs: [search.value.identifier], resultsPerPage: itemsPerPage }
    try {
        const response = await proxy.$axios.post("/public/shop/query",obj,
            {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-SOFTTOKEN': softToken,
                    'X-Auth-USER': username
                },
            },
        );
        if (response.data.status == "OK") {
            itemsFetched(response)
        }
    } catch (error) {
        console.error("Error: ", error);
    }
}
const itemsFetched = (response) => {
    serverItems.value = response.data.data;
    totalItems.value = response.data.totalElements
    loading.value = false
}



// const loadChildren = async (item) => {
//   if (item.children?.length) return; // Prevent reloading if already set

//   // Simulate delay (if needed)
//   await new Promise(resolve => setTimeout(resolve, 300));

//   // Find preloaded data and attach it dynamically
//   item.children = item.preloadedChildren || [];
// };


// Compute filtered data dynamically

const closeSheet = () => {
    dialogVisible.value = false;
    formData.value = {
        translations: { DE: { value: '' }, EN: { value: '' } },
    };
};
onMounted(() => {

});
</script>

<style>
.v-field--appended {
    padding-inline-end: 0px !important;
}

.v-col>.v-label,
.v-col>.v-checkbox .v-label {
    font-weight: 700;
    font-size: 14px;
    opacity: 1;
}

.shop-description-input textarea,
.shop-info-container .v-field__input {
    font-size: 14px !important;
    font-weight: 300 !important;
}

.emoji-picker-container {
    width: 300px;
    /* Adjust width as needed */
    height: 400px;
    /* Adjust height as needed */
    overflow-y: auto;
    /* Add scroll if content overflows */
    padding: 8px;
}

.date-picker .v-field .v-field__append-inner {
    background-color: rgb(var(--v-theme-default)) !important;
}

.time-input .v-field__input {
    padding-right: 0px;
}

.create-news-tabs .v-tab {
    font-weight: 600 !important;
}
</style>

<style scoped>
.v-tab-selected {
    border: 1px solid #ddd !important;
    border-bottom: 0 !important;
}

.v-window-item--active {
    border-top: 0 !important;
    border: 1px solid #ddd !important;
}

.highlighted-country {
    font-weight: 800;
}
</style>
